import { EVENT_ACTIONS, EVENT_DOMAINS, EVENT_SCREENS, EVENT_TYPES, EVENT_WIDGETS } from '../../../lib/analytics/constants';
import logger from '../../../lib/analytics/logger';
import { PIGGY_BANK_EVENT_TYPES } from '../constants';
export var sendPiggyBankEvent = function sendPiggyBankEvent(eventType) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (eventType) {
    case PIGGY_BANK_EVENT_TYPES.ENTER_PIGGY_BANK_SCREEN:
      logger.sendEvent(EVENT_TYPES.UI_EVENT, {
        action: EVENT_ACTIONS.DISPLAY,
        domain: EVENT_DOMAINS.PIGGY_BANK,
        screen: EVENT_SCREENS[EVENT_DOMAINS.GENERAL].MAIN,
        payload: payload
      });
      break;
    case PIGGY_BANK_EVENT_TYPES.EXIT_PIGGY_BANK_SCREEN:
      logger.sendEvent(EVENT_TYPES.UI_EVENT, {
        action: EVENT_ACTIONS.PRESS,
        domain: EVENT_DOMAINS.PIGGY_BANK,
        screen: EVENT_SCREENS[EVENT_DOMAINS.GENERAL].LOBBY,
        widget: EVENT_WIDGETS[EVENT_DOMAINS.GENERAL].DISMISS_BUTTON,
        payload: payload
      });
      break;
    case PIGGY_BANK_EVENT_TYPES.SHOW_PIGGY_BANK_TOOLTIP:
      logger.sendEvent(EVENT_TYPES.UI_EVENT, {
        action: EVENT_ACTIONS.DISPLAY,
        domain: EVENT_DOMAINS.PIGGY_BANK,
        screen: EVENT_SCREENS[EVENT_DOMAINS.GENERAL].LOBBY,
        widget: EVENT_WIDGETS[EVENT_DOMAINS.PIGGY_BANK].PIGGY_BANK_TOOLTIP,
        payload: payload
      });
      break;
    case PIGGY_BANK_EVENT_TYPES.PIGGY_BANK_WIDGET_CLICK:
      logger.sendEvent(EVENT_TYPES.UI_EVENT, {
        action: EVENT_ACTIONS.PRESS,
        domain: EVENT_DOMAINS.PIGGY_BANK,
        screen: EVENT_SCREENS[EVENT_DOMAINS.GENERAL].LOBBY,
        widget: EVENT_WIDGETS[EVENT_DOMAINS.PIGGY_BANK].PIGGY_BANK_WIDGET,
        payload: payload
      });
      break;
    case PIGGY_BANK_EVENT_TYPES.PIGGY_BANK_DISPLAY_TUTORIAL:
      logger.sendEvent(EVENT_TYPES.UI_EVENT, {
        action: EVENT_ACTIONS.DISPLAY,
        domain: EVENT_DOMAINS.PIGGY_BANK,
        screen: EVENT_SCREENS[EVENT_DOMAINS.GENERAL].INFO,
        payload: payload
      });
      break;
    case PIGGY_BANK_EVENT_TYPES.PIGGY_BANK_SKIP_TUTORIAL:
      logger.sendEvent(EVENT_TYPES.UI_EVENT, {
        action: EVENT_ACTIONS.PRESS,
        domain: EVENT_DOMAINS.PIGGY_BANK,
        screen: EVENT_SCREENS[EVENT_DOMAINS.GENERAL].INFO,
        widget: EVENT_WIDGETS[EVENT_DOMAINS.PIGGY_BANK].PIGGY_BANK_SKIP_TUTORIAL_BUTTON,
        payload: payload
      });
      break;
    case PIGGY_BANK_EVENT_TYPES.PIGGY_BANK_FINISH_TUTORIAL:
      logger.sendEvent(EVENT_TYPES.UI_EVENT, {
        action: EVENT_ACTIONS.PRESS,
        domain: EVENT_DOMAINS.PIGGY_BANK,
        screen: EVENT_SCREENS[EVENT_DOMAINS.GENERAL].INFO,
        widget: EVENT_WIDGETS[EVENT_DOMAINS.PIGGY_BANK].PIGGY_BANK_FINISH_TUTORIAL_BUTTON,
        payload: payload
      });
      break;
    default:
      break;
  }
};